import React from 'react'
import Layout from 'components/Layout'
import ScreenShell from 'components/ScreenShell/ScreenShell'
import RenderSubRoutes from 'components/RenderSubRoutes'
import getAdminRoutes from './getRoutes/getAdminRoutes'
import routes from 'constants/routes'
import { useParams, useLocation } from 'react-router-dom'
import useMediaQuery from 'hooks/useMediaQuery'
import * as _ from 'styles/helpers'

const Admins_Show = tool => {
	const { toolType } = useParams()
	const location = useLocation()
	const isMobile = useMediaQuery(_.MQ.small_and_below)

	const subRoutes = getAdminRoutes(toolType)

	// Check if on UserProfile page in mobile mode
	const isUserProfileMobile = isMobile && location.pathname.includes('/admin/userprofile')

	// If on UserProfile in mobile, render without Layout wrapper
	if (isUserProfileMobile) {
		return <RenderSubRoutes routes={subRoutes} />
	}

	return (
		<ScreenShell>
		<Layout>
			<Layout.SecondaryNav
				links={subRoutes}
				backLink={{ title: 'Admin Tools', link: routes.ADMIN }}
				sourceName={`Admin Tools`}
			/>

			<Layout.Page>
				<Layout.Sidebar isOffset>
					<Layout.SidebarUserCard />
				</Layout.Sidebar>
				<Layout.Body>
					<RenderSubRoutes routes={subRoutes} />
				</Layout.Body>
			</Layout.Page>
		</Layout>
		</ScreenShell>
	)
}

export default Admins_Show
